import type { useGT } from 'gt-react';
import type { CellViolationDetail } from '@erp/item-master-rules';

type Gt = ReturnType<typeof useGT>;
type ColumnNamer = (field: string) => string;

type WarningCodeDetail = Extract<
  CellViolationDetail,
  { rule: 'not-on-allowlist' | 'warning-code-placement' }
>;

export function isWarningCodeDetail(
  detail: CellViolationDetail,
): detail is WarningCodeDetail {
  return (
    detail.rule === 'not-on-allowlist' ||
    detail.rule === 'warning-code-placement'
  );
}

export function describeWarningCodeViolation(
  gt: Gt,
  detail: CellViolationDetail,
  column: string,
  value: string,
  name: ColumnNamer,
): string | null {
  if (detail.rule === 'not-on-allowlist') {
    return gt('{column} {value} is not on the warning-code allowlist.', {
      column,
      value,
      context:
        'review grid validation: the typed warning code (in quotes) is not one of the known existing codes; does not list the allowlist',
    });
  }
  if (detail.rule !== 'warning-code-placement') return null;
  return detail.required
    ? gt('{column} {value} must be in {slot}. Move it there to save.', {
        column,
        value,
        slot: name(detail.slot),
        context:
          'review grid validation: a warning code (in quotes) is in the wrong of the three PROD WARN CODE columns and Save will refuse it until it is moved',
      })
    : gt(
        '{column} {value} is usually placed in {slot}. Saving is still allowed.',
        {
          column,
          value,
          slot: name(detail.slot),
          context:
            'review grid validation warning: a warning code (in quotes) is not in its preferred PROD WARN CODE column; the author can still save',
        },
      );
}
